<template>
  <div>
  
<div v-if=" !showContent 
" class="content-loading">
      <base-loading  v-if="showItem" color="var(--default)" />
    </div>

     <div v-else class="content">
      <base-box class="heat-map w-100">
        <l-map
          v-if="heatmap.data.length >= 0"
          :zoom="11"
          :center="heatmapCenter"
          :scroll-wheel-zoom="false"
        >
          <l-tile-layer
            :url="`https://mt0.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&apistyle=${googleApiStyle}`"
            attribution="<a href='https://google.com/maps'>Powered by Google</a>"
          ></l-tile-layer>
          <LeafletHeatmap
            :lat-lng="heatmap.data"
            :options="heatmap.options"
          ></LeafletHeatmap>
        </l-map>
      </base-box>

      <div class="row chart top-negative">
        <div
          class="col-xs-12 col-md-12 col-lg-8"
          :class="isMobile ? '' : 'pr_10'"
        >
          <chart-box
            :reload-chart="reloadChart.ordersGrowth"
            title="Fluxo de novos pedidos"
            :showChangeMonth="true"
            @changePeriod="changePeriod"
            from="ordersGrowth"
            type="line"
            :chartData="charts.ordersGrowth.data"
            :chartOptions="charts.ordersGrowth.options"
            class="chart-labeled line-chart"
            :width="300"
            :height="300"
          />
        </div>
        <div
          class="col-xs-12 col-md-12 col-lg-4"
          :class="isMobile ? 'top-negative' : 'pl_10'"
        >
          <chart-box
            :drawer="true"
            :reload-chart="reloadChart.ordersRegions"
            title="Pedidos por bairro"
            :headers="['Bairro', 'Pedidos']"
            :all-items="ranking.ordersRegions"
            type="doughnut"
            :chart-data="charts.ordersRegions.data"
            :chart-options="charts.ordersRegions.options"
            class="doughnut-chart"
            :width="300"
            :height="300"
          />
        </div>
      </div>

      <base-box class="msg-charts">
        <base-message>
          Para ver os gráficos disponíveis, vire seu celular em modo paisagem.
        </base-message>
      </base-box>

      <filter-period
        :open="drawers.filter.ordersGrowth.open"
        :close="drawers.filter.ordersGrowth.close"
        @filter="filterPeriod"
        :maxCustomRange="0"
        :day-filter="false"
        :year-filter="false"
        :custom-filter="false"
      />
  </div>
  </div>
</template>

<script>
// components
import BaseBox from '@/components/Box';
import ChartBox from '@/containers/ChartBox';
import BaseMessage from '@/components/Message';
import BaseLoading from '@/components/Loading';
// containers
import FilterPeriod from '@/containers/FilterPeriod';
// libs
import { LMap, LTileLayer, LMarker } from '@eluiz/vue2-leaflet';
import LeafletHeatmap from '@/containers/HeatMap';
import dayjs from 'dayjs';
import { mapState } from 'vuex';
// api
import ApiReports from '@/api/reports';

export default {
  components: {
    BaseBox,
    ChartBox,
    BaseMessage,
    BaseLoading,
    FilterPeriod,
    LMap,
    LTileLayer,
    LMarker,
    LeafletHeatmap,
  },
  props: {
    showLoading: { type: Boolean },
    showItem: {type: Boolean}

  },
  data() {
    return {
      reloadChart: {
        ordersGrowth: false,
        ordersRegions: false,
      },
      period: {
        default: [
          dayjs().format('YYYY-MM-[01] 00:00:00'),
          `${dayjs().format('YYYY-MM')}-${dayjs().daysInMonth()} 23:59:59`,
        ],
        ordersGrowth: [
          dayjs().format('YYYY-MM-[01] 00:00:00'),
          `${dayjs().format('YYYY-MM')}-${dayjs().daysInMonth()} 23:59:59`,
        ],
        customerGrowth: [
          dayjs().format('YYYY-MM-[01] 00:00:00'),
          `${dayjs().format('YYYY-MM')}-${dayjs().daysInMonth()} 23:59:59`,
        ],
      },
      ranking: {},
      totals: {},
      heatmap: {
        data: [],
        options: {
          radius: 25,
        },
        center: [],
      },
      googleApiStyle:
        's.e%3Ag%7Cp.c%3A%23ff242f3e%2Cs.e%3Al.t.f%7Cp.c%3A%23ff746855%2Cs.e%3Al.t.s%7Cp.c%3A%23ff242f3e%2Cs.t%3A19%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A2%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A40%7Cs.e%3Ag%7Cp.c%3A%23ff263c3f%2Cs.t%3A40%7Cs.e%3Al.t.f%7Cp.c%3A%23ff6b9a76%2Cs.t%3A3%7Cs.e%3Ag%7Cp.c%3A%23ff38414e%2Cs.t%3A3%7Cs.e%3Ag.s%7Cp.c%3A%23ff212a37%2Cs.t%3A3%7Cs.e%3Al.t.f%7Cp.c%3A%23ff9ca5b3%2Cs.t%3A49%7Cs.e%3Ag%7Cp.c%3A%23ff746855%2Cs.t%3A49%7Cs.e%3Ag.s%7Cp.c%3A%23ff1f2835%2Cs.t%3A49%7Cs.e%3Al.t.f%7Cp.c%3A%23fff3d19c%2Cs.t%3A4%7Cs.e%3Ag%7Cp.c%3A%23ff2f3948%2Cs.t%3A66%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A6%7Cs.e%3Ag%7Cp.c%3A%23ff17263c%2Cs.t%3A6%7Cs.e%3Al.t.f%7Cp.c%3A%23ff515c6d%2Cs.t%3A6%7Cs.e%3Al.t.s%7Cp.c%3A%23ff17263c',
      charts: {
        defaultColor: [
          {
            backgroundColor: '#FF338220',
            borderColor: '#FF3382',
            pointBackgroundColor: '#FF3382',
          },
          {
            backgroundColor: '#2E303370',
            borderColor: '#9999996B',
            pointBackgroundColor: '#999999',
          },
        ],
        ordersRegions: {
          data: {
            labels: [],
            datasets: [
              {
                borderWidth: 0,
                backgroundColor: [
                  '#ea527e',
                  '#ce4568',
                  '#ba7892',
                  '#bbb',
                  '#ddd',
                  '#eee',
                ],
                data: [],
              },
            ],
          },
          options: {
            cutoutPercentage: 62.5,
            maintainAspectRatio: false,
            responsive: true,
            legend: {
              position: 'bottom',
              fullWidth: false,
              align: 'start',
              labels: {
                boxWidth: 20,
                padding: 20,
              },
            },
            tooltips: {
              callbacks: {
                label(tooltipItem, data) {
                  const name = data.labels[tooltipItem.index];
                  const value = data.datasets[0].data[tooltipItem.index];

                  return name === 'Sem informações'
                    ? ` ${name}`
                    : ` ${name}: ${value}`;
                },
              },
            },
          },
        },
        ordersGrowth: {
          data: {
            labels: [],
            datasets: [],
          },
          options: {
            maintainAspectRatio: false,
            responsive: true,
            legend: {
              display: false,
            },
            elements: {
              line: {
                tension: 0,
              },
            },
            scales: {
              title: {
                scaleShowLabels: false,
              },
              xAxes: [
                {
                  ticks: {
                    maxTicksLimit: 16,
                  },
                  gridLines: {
                    color: '#70707061',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {},
                  gridLines: {
                    color: '#70707061',
                  },
                },
              ],
            },
            animation: {
              duration: 1000,
            },
          },
        },
      },
      dayjs,
      drawers: {
        filter: {
          ordersGrowth: {
            open: false,
            close: false,
          },
          from: 'default',
        },
      },
      filter: {
        consolidated: {
          type: 'day',
          periods: [],
        },
      },
      showContent: false,
    };
  },
  created() {
    this.filterPeriod();
  },
  methods: {
    async search() {
      const esFilter = {
        query: [
          {
            index: 'report-orders',
            type: 'aggs',
            queries: [
              {
                match: {
                  status: 4,
                },
              },
            ],
            aggs: {
              orders_currently: {
                date_range: {
                  field: 'created_at',
                  ranges: [
                    {
                      from: dayjs(this.period.ordersGrowth[0]).format(
                        'YYYY-MM-DDTHH:mm:ssZ[Z]',
                      ),
                      to: dayjs(this.period.ordersGrowth[1]).format(
                        'YYYY-MM-DDTHH:mm:ssZ[Z]',
                      ),
                    },
                  ],
                },
                aggs: {
                  orders_per_day: {
                    date_histogram: {
                      field: 'created_at',
                      interval: 'day',
                      min_doc_count: 1,
                    },
                  },
                },
              },
              orders_previous: {
                date_range: {
                  field: 'created_at',
                  ranges: [
                    {
                      from: dayjs(this.period.ordersGrowth[0])
                        .subtract(1, 'month')
                        .format('YYYY-MM-DDTHH:mm:ssZ[Z]'),
                      to: dayjs(this.period.ordersGrowth[1])
                        .subtract(1, 'month')
                        .format('YYYY-MM-DDTHH:mm:ssZ[Z]'),
                    },
                  ],
                },
                aggs: {
                  orders_per_day: {
                    date_histogram: {
                      field: 'created_at',
                      interval: 'day',
                      min_doc_count: 1,
                    },
                  },
                },
              },
              order_regions: {
                terms: {
                  field: 'delivery.region',
                },
                aggs: {
                  geolocation: {
                    top_hits: {
                      _source: {
                        includes: ['delivery.geolocation'],
                      },
                      size: 1,
                    },
                  },
                  customers: {
                    top_hits: {
                      _source: {
                        includes: ['payers.user.id'],
                      },
                    },
                  },
                },
              },
            },
          },
          {
            index: 'report-orders',
            type: 'aggs',
            queries: [
              {
                bool: {
                  should: [
                    {
                      match: {
                        status: 4,
                      },
                    },
                    {
                      match: {
                        status: -1,
                      },
                    },
                  ],
                },
              },
            ],
            aggs: {
              orders_total: {
                date_range: {
                  field: 'created_at',
                  ranges: [
                    {
                      from: dayjs(new Date('1901-01-01')).format(
                        'YYYY-MM-DDTHH:mm:ssZ[Z]',
                      ),
                      to: dayjs(new Date()).format('YYYY-MM-DDTHH:mm:ssZ[Z]'),
                    },
                  ],
                },
              },
            },
          },
        ],
      };

      const apiResponse = await ApiReports.reports(esFilter);
      const ordersGrowth = [];

      this.totals.orders = apiResponse.data[1].orders_total.buckets[0].doc_count;

      ordersGrowth.push(
        this.formatResponseDataLineChart(
          apiResponse.data[0].orders_currently.buckets[0].orders_per_day.buckets,
        ),
      );
      ordersGrowth.push(
        this.formatResponseDataLineChart(
          apiResponse.data[0].orders_previous.buckets[0].orders_per_day.buckets,
        ),
      );
      this.charts.ordersGrowth.options.scales.yAxes[0].ticks.min = 0;

      this.ranking.ordersRegions = apiResponse.data[0].order_regions.buckets.map((item) => ({
        name: item.key,
        value: item.doc_count,
        geolocation: item.geolocation.hits.hits[0]._source.delivery
          ? item.geolocation.hits.hits[0]._source.delivery.geolocation
          : [-25.4597650, -49.2849022,
          ],
      }));

      this.formatDataLineChart(ordersGrowth, 'ordersGrowth', 'day');

      this.setHeatMap();
      this.setChartsData('ordersRegions');

      switch (this.drawers.filter.from) {
        case 'ordersGrowth':
          this.reloadChart.ordersGrowth = !this.reloadChart.ordersGrowth;
          break;
        default:
          this.reloadChart.ordersGrowth = !this.reloadChart.ordersGrowth;
          this.reloadChart.ordersRegions = !this.reloadChart.ordersRegions;
          break;
      }

      this.$forceUpdate();
    },
    setChartsData(param) {
      const labels = this.handleChartData(
        this.ranking[param].map((item) => item.name),
        'labels',
      );
      const values = this.handleChartData(
        this.ranking[param].map((item) => item.value),
        'values',
      );
      // atualiza labels
      this.charts[param].data.labels = labels.filter((label, i) => (i <= 4 ? label : ''));
      // atualiza valores
      let othersValue = 0;
      this.charts[param].data.datasets[0].data = values.filter((value, i) => {
        if (i <= 4) return value;
        othersValue += value;
      });

      if (this.ranking[param].length === 0) {
        this.charts[param].data.datasets[0].backgroundColor = ['#ccc'];
      } else {
        this.charts[param].data.labels.push('Outros');
        this.charts[param].data.datasets[0].data.push(othersValue);
      }
    },
    handleChartData(data, type) {
      let transformedData = data;

      if (!data || data.length === 0) { transformedData = type === 'values' ? [-1] : ['Sem informações']; }

      return transformedData;
    },
    setHeatMap() {
      this.heatmap.data = [];
      this.ranking.ordersRegions.forEach((item) => {
        this.heatmap.data.push([
          item.geolocation[0],
          item.geolocation[1],
          item.value,
        ]);
      });
    },
    formatDataLineChart(data, name, type) {
      this.charts[name].data.datasets = [];
      const labelChart = [];

      for (let y = 0; y < 2; y++) {
        const dataOrderChart = [];
        for (
          let i = 1;
          i <= dayjs(this.period[name][0]).subtract(y, 'month').daysInMonth();
          i++
        ) {
          if (y == 0) {
            labelChart.push(
              `${i.toString().padStart(2, '0')}/${dayjs(this.period[name][0])
                .subtract(y, 'month')
                .format('MM')}`,
            );
          }

          this.charts[name].data.datasets.push;
          dataOrderChart.push(0);
        }

        this.charts[name].data.labels = labelChart;
        this.charts[name].data.datasets.push({
          label: dayjs(this.period[name][0])
            .subtract(y, 'month')
            .format('MMMM'),
          data: dataOrderChart,
          borderWidth: 1,
          backgroundColor: this.charts.defaultColor[y].backgroundColor,
          borderColor: this.charts.defaultColor[y].borderColor,
          pointBackgroundColor:
            this.charts.defaultColor[y].pointBackgroundColor,
        });
      }

      if (data) {
        data.forEach((item, idx) => {
          const dataOrderChart = [];
          let total = 0;

          if (item.length > 0) {
            for (let i = 1; i <= dayjs(item[0].date).daysInMonth(); i++) {
              dataOrderChart.push(0);
            }

            item.forEach((b) => {
              dataOrderChart[parseInt(dayjs(b.date).utc().format('D')) - 1] = b.count;
              total += b.count;
            });

            this.charts[name].data.datasets[idx].data = dataOrderChart;
          }

          this.charts[name].data.datasets[idx].label += ` (${total})`;
        });
      }
    },
    formatResponseDataLineChart(data) {
      return data.map((item) => ({
        date: item.key,
        date_as_string: item.key_as_string,
        count: item.doc_count,
      }));
    },
    changePeriod(chart) {
      this.drawers.filter.from = chart || 'default';
      this.drawers.filter[chart].open = !this.drawers.filter[chart].open;
    },
    async filterPeriod(filter = false) {
      const from = this.drawers.filter.from || 'default';
      this.filter.consolidated.periods[from] = [];
      // insere data de início e fim do mês
      if (!filter) {
        this.filter.consolidated.periods[from].push([
          dayjs().format('YYYY-MM-[01] 00:00:00'),
          `${dayjs().format('YYYY-MM')}-${dayjs().daysInMonth()} 23:59:59`,
        ]);
        this.filter.consolidated.periods[from].push([
          dayjs().subtract(1, 'month').format('YYYY-MM-[01] 00:00:00'),
          `${dayjs().subtract(1, 'month').format('YYYY-MM')}-${dayjs()
            .subtract(1, 'month')
            .daysInMonth()}`,
        ]);
      } else {
        // se filtro é passado usa ele e calcula menos 1 mês
        this.filter.consolidated.periods[from].push(filter.periods);
        this.filter.consolidated.periods[from].push([
          `${dayjs(filter.periods[0])
            .subtract(1, 'month')
            .format('YYYY-MM-[01] 00:00:00')}`,
          `${dayjs(filter.periods[0])
            .subtract(1, 'month')
            .format('YYYY-MM')}-${dayjs(filter.periods[0])
            .subtract(1, 'month')
            .daysInMonth()} 23:59:59`,
        ]);
      }

      if (from !== 'default') {
        this.drawers.filter[from].close = !this.drawers.filter[from].close;
      }

      if (filter) {
        this.period[from] = filter.periods;
      }
      await this.search();
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      screenWidth: (state) => state.store.screenWidth,
      configurations: (state) => state.store.configurations,
    }),
    heatmapCenter() {
      if (
        this.configurations
        && this.configurations.location
        && this.configurations.location.geolocation
      ) {
        return [
          this.configurations.location.geolocation.latitude,
          this.configurations.location.geolocation.longitude,
        ];
      }
      return [-25.4573827, -49.2877663];
    },
  },
  watch: {
    heatmap: {
      deep: true,
      handler(newValue) {
        if (newValue.data.length >= 0) {
          this.showContent = true;
        }
      
      },
    },
  },
};
</script>

<style scoped>
.heat-map {
  height: 360px;
}
.msg-charts {
  display: none;
}
.content-loading {
  height: calc(100vh - 280px);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.top-negative {
  margin-top: -10px;
}
@media screen and (max-width: 991px) {
 .heat-map{
      touch-action:none;
      pointer-events:none;
            }  
  @media screen and (orientation: portrait) {
    .heat-map,
    .chart {
      opacity: 0;
      position: absolute;
      top: 0;
      width: 0;
      overflow: hidden;
      padding: 0;
      margin: 0;
      z-index: -1;
    }
    .msg-charts {
      display: block;
    }
  }
}
</style>
